import { Injectable, OnDestroy } from "@angular/core";
import { BroadcastChannel, createLeaderElection } from "broadcast-channel";
import { BehaviorSubject, Subject } from "rxjs";
import { BroadcastMessages } from "src/app/shared/general/constants";
import { RefreshState } from "../models/login";
import { AccountService } from "./account.service";

@Injectable({ providedIn: "root" })
export class LeaderElectionService implements OnDestroy {
  private channel = new BroadcastChannel("blu-auth-app-channel");
  private elector = createLeaderElection(this.channel, {
    fallbackInterval: 500, // optional configuration for how often will renegotiation for leader occur
    responseTime: 1000, // optional configuration for how long will instances have to respond
  });

  private refreshStateSubject = new BehaviorSubject<RefreshState | null>(null);
  public refreshState$ = this.refreshStateSubject.asObservable(); // Exposed as a stream

  private isLeaderSubject = new BehaviorSubject<boolean>(false);
  private destroy$ = new Subject<void>();

  /** Observable that emits `true` when this tab is the leader */
  isLeader$ = this.isLeaderSubject.asObservable();

  get isLeader() {
    return this.elector.isLeader;
  }

  constructor(private readonly accountService: AccountService) {
    this.initLeaderElection();
    this.listenForRefreshUpdates();
  }

  private initLeaderElection() {
    this.elector.awaitLeadership().then(() => {
      this.isLeaderSubject.next(true);
      console.warn("leadership elected!");
    });

    this.elector.onduplicate = () => {
      console.warn("leadership duplicate");
      // this.elector.die();
      // this.isLeaderSubject.next(false);
    };
  }

  broadcastRefreshState(state: RefreshState): void {
    this.refreshStateSubject.next(state); // Emit locally
    this.isLeader &&
      this.channel.postMessage({
        type: BroadcastMessages.REFRESH_STATUS,
        origin: window.location.origin,
        token: this.accountService.getRefreshTokenFromCookie(),
        state,
      }); // Broadcast to other tabs
  }

  private listenForRefreshUpdates(): void {
    this.channel.addEventListener("message", (data) => {
      if (
        data &&
        data.type === BroadcastMessages.REFRESH_STATUS &&
        data.origin === window.location.origin &&
        data.token === this.accountService.getRefreshTokenFromCookie() &&
        "state" in data
      ) {
        this.refreshStateSubject.next(data.state); // Emit the received state
      }
    });
  }

  ngOnDestroy(): void {
    this.isLeaderSubject.complete();
    this.destroy$.next();
    this.destroy$.complete();
    this.elector.die();
    this.channel.close();
  }
}
